/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
// Import PolymerElement class
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import { mixinBehaviors } from "@polymer/polymer/lib/legacy/class.js"; // define the element's class element

class ProfileContactDetailsAddressEdit extends mixinBehaviors([sbBehaviours.authAndSubmit, accessibilityBehaviours.commonFunctions, corpBehaviours.appCommonBehaviour], PolymerElement) {
        static get template() {
            return html `
          <style  include="app-styles">   
            .marginRight2{
              margin-right:2%;
            } 
            oe-input{
            --paper-input-container-ms-clear: {
                    color: white;
                    height: 0;
                    width: 0;
              }
             --paper-input-container:{
                 padding-top:12px;
             } 
          }
          oe-combo{
            --paper-input-container:{
                padding-top:12px;
            }  
          }
         </style>
         <app-media-query phone={{phone}} tablet={{tablet}} desktop={{desktop}}></app-media-query>
          <!--Ajax call for city Type-->
         <oe-ajax id="countryAjaxCall" auto url="api/codereferences?filter[where][codeType]=CNT&filter[order]=codeDescription" on-response="accountListResponse" on-error="accountListError"></oe-ajax> 
       <!--Ajax call for state Type-->
       <oe-ajax id="stateAjaxCall"  url="/api/Statecodereferences?filter[where][countryCode]={{selectedAddressDetail.addressDetails.country.cmCode}}"
            last-response="{{stateList}}" on-response="_stateCall" on-error="_errorState"></oe-ajax>
      
        <div class="mdl-grid mdl-grid--no-spacing" hidden$={{phone}}>
          <div class="mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col content-align-left text-align-left">
            <div hidden$="{{displayIcon(leftAction.leftIcon)}}">
              <a href="{{leftAction.lefthref}}" tabIndex="-1" hidden$="{{leftAction.leftCallback}}">
                <paper-icon-button icon="{{leftAction.leftIcon}}" class="action-btn-rtl"></paper-icon-button>
              </a>
              <div hidden$="{{!leftAction.leftCallback}}">
                <paper-icon-button id="primary_account_back_button" icon="{{leftAction.leftIcon}}" on-tap="_confirmBack"  aria-label$="{{getLabel('l_Back')}}" role="button" class="action-btn-rtl"></paper-icon-button>
              </div>
            </div>
          </div>
          <div class="outlineOffset mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet mdl-cell--6-col content-align-center text-align-center title-dark" tabindex=0 id="address_edit_page">
            <oe-i18n-msg msgid="{{titlePage}}"></oe-i18n-msg>
          </div>
        </div>
      
      <div class="mdl-grid">
        <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col">           
          <oe-input  id="houseNumber" value="{{selectedAddressDetail.addressDetails.houseNumber}}" label="l_HouseNo" maxlength="9"></oe-input>   
          <oe-input  id="buildingLevel" value="{{selectedAddressDetail.addressDetails.buildingLevel}}" label="l_BuildingLvl" maxlength="9"></oe-input>            
          <oe-input  id="streetNumber" value="{{selectedAddressDetail.addressDetails.streetNumber}}" label="l_Streetnumber" maxlength="9"></oe-input>
          <oe-input  id="street_name" value="{{selectedAddressDetail.addressDetails.streetName}}" label="l_Streetname" maxlength="19"></oe-input>
          <oe-input  id="Suburb" value="{{selectedAddressDetail.addressDetails.suburb}}" label="l_Suburb" maxlength="19"></oe-input>
          <oe-input  id="Locality" value="{{selectedAddressDetail.addressDetails.locality}}" label="l_Locality" maxlength="15"></oe-input>       
          <oe-input  id="l_Town" value="{{selectedAddressDetail.addressDetails.town}}" label="l_Town" maxlength="25"></oe-input>
          <oe-input  id="cityid" value="{{selectedAddressDetail.addressDetails.cityDesc}}" label="h_City" maxlength="50"></oe-input>
            
          <div>
            <!-- State selection -->
            <oe-combo id="stateCombo" label="h_State"  value="{{state}}"
              displayproperty="stateDescription" scroll-action="cancel" listdata="{{stateList}}"
              error-message="m_stateErr" user-error-message="m_stateErr" disabled="{{showState}}">
            </oe-combo>
          </div>
          <div class="position-relative">
          <div class="mdl-cell"></div>
            <app-data-selection required filter-val="{{filterVal}}" id="countrySelector" search-input-id="countrySelectorInputId" 
              display-label="h_Country" data="{{countryList}}" sub-header="h_Country" 
              selected-row="{{selectedAddressDetail.addressDetails.country}}" data-columns="{{countryDataColumns}}"
              display-field="codeDescription" fields="codeDescription" on-row-selected="_SelectedThroughSelector">
            </app-data-selection>
          </div>
          <oe-input id="zipid" value="{{selectedAddressDetail.addressDetails.zipCode}}"  label="h_Zipcode" maxlength="10"></oe-input>

          <div class="margin-l-zero mdl-grid padding-l-zero">
          <template is="dom-if" if="{{selectedAddressDetail.alwaysPreferred}}">
          <div class="content-align-vertical-center full-width margin-l-zero padding-l-zero mdl-grid">
                      <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-disabled="true" aria-checked="false" aria-labelledby="{{getLabel('l_unselected')}}" id="unchecked_icon" icon="radio-button-unchecked" class="outlineOffset circle-unchecked marginRight2" hidden={{selectedAddressDetail.preferredAddress}} on-tap="_checkUncheckAll" ></iron-icon>
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-disabled="true" aria-checked="true" aria-labelledby="{{getLabel('m_selected')}}" id="checked_icon" icon="check-circle" class="outlineOffset circle-unchecked marginRight2" hidden={{!selectedAddressDetail.preferredAddress}} on-tap="_checkUncheckAll"></iron-icon>
                  <oe-i18n-msg class="font-size-m" msgid="l_setAsPreferedAddress"></oe-i18n-msg>
              </div>
          </template>
          <template is="dom-if" if="{{!selectedAddressDetail.alwaysPreferred}}">
            <template is="dom-if" if="{{selectedAddressDetail.isAddressPresent}}">
              <div class="content-align-vertical-center full-width margin-l-zero padding-l-zero mdl-grid">
                      <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="false" aria-labelledby="{{getLabel('l_unselected')}}" id="unchecked_icon" icon="radio-button-unchecked" class="outlineOffset circle-unchecked cursor-pointer marginRight2" hidden={{selectedAddressDetail.preferredAddress}} on-tap="_checkUncheckAll" ></iron-icon>
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="true" aria-labelledby="{{getLabel('m_selected')}}" id="checked_icon" icon="check-circle" class="outlineOffset circle-checked cursor-pointer text-brand-color marginRight2" hidden={{!selectedAddressDetail.preferredAddress}} on-tap="_checkUncheckAll"></iron-icon>
                  <oe-i18n-msg class="font-size-m" msgid="l_setAsPreferedAddress"></oe-i18n-msg>
              </div>
            </template>
            <template is="dom-if" if="{{!selectedAddressDetail.isAddressPresent}}">
              <div class="content-align-vertical-center full-width margin-l-zero padding-l-zero mdl-grid">
                      <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="false" aria-disabled="true" aria-labelledby="{{getLabel('l_unselected')}}" id="unchecked_icon" icon="radio-button-unchecked" class="outlineOffset circle-unchecked marginRight2" hidden={{selectedAddressDetail.preferredAddress}} on-tap="_checkUncheckAll"></iron-icon>
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="true" aria-disabled="true" aria-labelledby="{{getLabel('m_selected')}}" id="checked_icon" icon="check-circle" class="outlineOffset circle-unchecked marginRight2" hidden={{!selectedAddressDetail.preferredAddress}} on-tap="_checkUncheckAll"></iron-icon>
                  <oe-i18n-msg class="font-size-m disabled-dark-color" msgid="l_setAsPreferedAddress"></oe-i18n-msg>
              </div>
            </template>
          </template>
          </div>
        </div>
      </div>
          
        <div class="text-align-center">
            <paper-button id="updateAddressBtn" on-keydown = "setFocus" on-tap="confirmAddress" class="primary-button">
                <oe-i18n-msg msgid="b_Update" class="style-scope"></oe-i18n-msg>
            </paper-button>
        </div>
        <div class="mdl-grid"></div>
        <div class="mdl-grid"></div>


        <app-dialog id="backNagigationPopup" closevisible="{{closevisible}}" elementid="backNagigationPopup">
          <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet">
              <oe-i18n-msg msgid="m_backNavigationError" class="font-size-m"></oe-i18n-msg>
              </div>
              <div class="mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
                <paper-button id="submitLoanEmailFormAuthsubmit" on-tap="_leftAction" on-keypress="_leftAction" class="flat-button">
                  <oe-i18n-msg id="loan_acct_email_form_emailLoanSubmitButton" class="text-brand-color" msgid="b_Yes"></oe-i18n-msg>
                </paper-button>
                <paper-button id="submitLoanEmailFormAuthsubmit" on-tap="_cancelBack" on-keypress="_cancelBack" class="flat-button">
                  <oe-i18n-msg id="loan_acct_email_form_emailLoanSubmitButton" class="text-brand-color" msgid="b_No"></oe-i18n-msg>
                </paper-button>
              </div>
          </div>
        </app-dialog>

         <!-- app dialog for authorization i.e. transaction  password -->
 
         <app-dialog name="h_Authorization" id="addressUpdateAuthorization" elementid="addressUpdateAuthorization">
          <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet">
                <fin-auth-element-wrapper id="loan_acct_email_form_authPaymentStopWrapper" auth-method="{{authMethods}}"></fin-auth-element-wrapper>
              </div>
              <div class="mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
                <paper-button id="submitLoanEmailFormAuthsubmit" on-tap="_continueToConfirm" on-keypress="_continueToConfirm" class="flat-button">
                  <oe-i18n-msg id="loan_acct_email_form_emailLoanSubmitButton" class="text-brand-color" msgid="b_Submit"></oe-i18n-msg>
                </paper-button>
              </div>
          </div>
        </app-dialog>
         
          `;
        }

        static get properties() {
            return {
                selectedContactType: {
                    type: Number,
                    notify: true
                },
                myprofilepagenumber: {
                    type: Number,
                    notify: true,
                    observer: 'resetAuth'
                },
                selectedAddressDetail: {
                    type: Object,
                    notify: true
                },

                /*Country COCD list*/
                countryList: {
                    type: Array,
                    notify: true
                },
                // selected country 
                country: {
                    type: Object,
                    notify: true,
                    Observer: 'countryChanged'
                },
                //state for address details
                state: {
                    type: Object,
                    notify: true,
                    observer: 'stateChanged'
                },
                showState: {
                    type: Boolean,
                    notify: true,
                    value: true
                },
                addressDetails: {
                    type: Object,
                    notify: true
                },
                /*Popup column list*/
                countryDataColumns: {
                    type: Array,
                    notify: true,
                    value: [{
                        key: 'codeDescription',
                        label: 'h_Country'
                    }]
                },
                filterVal: {
                    type: String,
                    notify: true,
                    value: ""

                },
                closevisible: {
                    type: Boolean,
                    value: false
                },
                //To store authentication methods
                authMethods: {
                    type: Array,
                    notify: true
                },
                addressList: {
                    type: Array,
                    notify: true
                },
                fromEditPage: {
                  type: Boolean,
                  value: false,
                  notify: true
                },
                personalDetailsResponse: {
                  type: Array,
                  notify: true
                }
            };
        }

        static get observers() {
            return ['countryChanged(selectedAddressDetail.addressDetails.country)',
                'selectedAddressChange(selectedAddressDetail)',
                'stateChanged(state,selectedAddressDetail.addressDetails.cityDesc,selectedAddressDetail.addressDetails.country,selectedAddressDetail.addressDetails.zipCode)'
            ];
        }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('iron-overlay-closed', this._clearAuthMethods);
  } //observer for selectedAddressDetail

        resetAuth(n) {
            if (n == 9)
                this.authMethods = []
        }
  _clearAuthMethods() {
    this.authMethods = [];
  }
        _SelectedThroughSelector() {
            if (!(Object.keys(this.selectedAddressDetail.addressDetails).length === 0)) {
                if (this.country) {
                    if (!(this.country.codeDescription == this.selectedAddressDetail.addressDetails.country.codeDescription))
                        this.set('state', {});
                }
                this.showState = false;
                this.$$("#stateAjaxCall").generateRequest();
            }
        }

        stateChanged() {
            if (!(Object.keys(this.selectedAddressDetail.addressDetails).length === 0)) {
                if (this.selectedAddressDetail.addressDetails.cityDesc == "" || this.selectedAddressDetail.addressDetails.cityDesc == undefined ||
                    (this.selectedAddressDetail.addressDetails.country == {} || this.selectedAddressDetail.addressDetails.country == undefined || Object.keys(this.selectedAddressDetail.addressDetails.country).length === 0) ||
                    (this.state == null || this.state == undefined || Object.keys(this.state).length === 0) ||
                    this.selectedAddressDetail.addressDetails.zipCode == "" || this.selectedAddressDetail.addressDetails.zipCode == undefined) {
                    this.set('selectedAddressDetail.isAddressPresent', false);
                } else {
                    this.set('selectedAddressDetail.isAddressPresent', true);
                }
            }
        }

        selectedAddressChange() {
                this.country = undefined;
                this.state = undefined;
                this.showState = true;
                if (!(Object.keys(this.selectedAddressDetail.addressDetails).length === 0)) {
                    this.country = this.selectedAddressDetail.addressDetails.country;
                    this.state = this.selectedAddressDetail.addressDetails.state;
                } else {
                    this.stateList = [];
                }
            } //response for api call for country


        accountListResponse(e) {
                var response = e.detail.response;
                this.set('countryList', response);
                this.fire('stop-processing-loader');
            } //to change preferred address button


        _checkUncheckAll() {
                var self = this;
                if (this.selectedAddressDetail.addressType != this.selectedAddressDetail.preferedAddressType) {
                    if (this.selectedAddressDetail.isAddressPresent) {
                        var prefered = !this.selectedAddressDetail.preferredAddress;
                        if (prefered == true) {
                            setTimeout(function() { self.shadowRoot.querySelector('#checked_icon').focus(); }, 500);
                        } else {
                            setTimeout(function() { self.shadowRoot.querySelector('#unchecked_icon').focus(); }, 500);
                        }
                        this.set('selectedAddressDetail.preferredAddress', prefered);
                        this.selectedAddressDetail.tempFlag = !this.selectedAddressDetail.tempFlag;
                    }
                }
            } //calls on change of country


        countryChanged() {
                if (!(Object.keys(this.selectedAddressDetail.addressDetails).length === 0)) {
                    if (this.selectedAddressDetail.addressDetails.country == undefined || Object.keys(this.selectedAddressDetail.addressDetails.country).length === 0) {
                        this.set('state', {})
                        this.showState = true;
                    } else {
                        this.showState = false;
                        this.stateList = [];
                        this.$$("#stateAjaxCall").generateRequest();
                    }
                }
            } //error method for state ajax call


        _errorState() {
                this.set('state', {})
                this.stateList = [];
                this.$.stateCombo.invalid = true;
                this.$.stateCombo.errorMessage = 'm_statesAreNotAvailableForRespectiveCountryCode';
            } //success method for state api call


        _stateCall(event) {
            if (this.stateList) {
                if (this.stateList.length == 0) {
                    var response = event.detail.response;

                    if (response !== "") {
                        this.stateList = event.detail.response;
                        /**Defect fixed 310516 for Reset State after country changed */
                        if (!(Object.keys(this.selectedAddressDetail.addressDetails).length == 0)) {
                            if (!this.selectedAddressDetail.addressDetails.hasOwnProperty('state')) {
                                this.set('state', {});
                            }
                        }

                        if (document.getElementById('stateCombo')) {
                            document.getElementById('stateCombo').invalid = false;
                            document.getElementById('stateCombo').errorMessage = '';
                        }
                    } else {
                        this.stateList = [];

                        if (document.getElementById('stateCombo')) {
                            document.getElementById('stateCombo').invalid = true;
                            document.getElementById('stateCombo').errorMessage = 'm_statesAreNotAvailableForRespectiveCountryCode';
                        }
                    }
                }
            }

        }

        confirmAddress() {
            this.$$("#cityid").invalid = false;
            this.$$("#stateCombo").invalid = false;
            this.$$("#countrySelector").invalid = false;
            this.$$("#zipid").invalid = false;
            this.$$("#streetNumber").invalid = false;
            this.$$("#street_name").invalid = false;

            if (this.validate()) {

                if (this.authMethods == undefined || this.authMethods && this.authMethods.length == 0) {
                    this.authMethods = [];
                    this.header = [];
                }
                var self = this;
                var preferredAddress = "";
                if (self.addressList[0].contactAddress) {
                    for (let i = 0; i < self.addressList[0].contactAddress.length; i++) {
                        if (self.addressList[0].contactAddress[i].addressType == self.selectedAddressDetail.addressType) var contactAddress = self.addressList[0].contactAddress[i];
                        if (self.selectedAddressDetail.preferredAddress == true) preferredAddress = self.selectedAddressDetail.addressType;
                        else if (self.selectedAddressDetail.preferredAddress == false) preferredAddress = "";
                        else if (self.addressList[0].preferredAddress.cmCode == "Y") preferredAddress = self.addressList[0].contactAddress[i].addressType;
                    }
                }

                var body = {};
                body["customerId"] = clientStorage.get(storageType.session, 'customerId');
                if(!self.addressList[0].contactAddress && preferredAddress==""){
					body["preferredAddress"] = self.selectedAddressDetail.addressType;
				}
				else{
					body["preferredAddress"] =preferredAddress;
				}
                body[self.selectedAddressDetail.aType] = {
                    "addressId": self.selectedAddressDetail.addressId,
                    "houseNo": self.selectedAddressDetail.addressDetails.houseNumber,
                    "buildingLevel": self.selectedAddressDetail.addressDetails.buildingLevel,
                    "streetNo": self.selectedAddressDetail.addressDetails.streetNumber,
                    "streetName": self.selectedAddressDetail.addressDetails.streetName,
                    "suburb": self.selectedAddressDetail.addressDetails.suburb,
                    "locality": self.selectedAddressDetail.addressDetails.locality,
                    "town": self.selectedAddressDetail.addressDetails.town,
                    "city": self.selectedAddressDetail.addressDetails.cityDesc,
                    "state": self.state.stateCode,
                    "country": self.selectedAddressDetail.addressDetails.country.cmCode,
                    "zipCode": self.selectedAddressDetail.addressDetails.zipCode
                };
                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/personaldetails-requests';
                ajaxCall.method = 'POST';
                ajaxCall.body = body;
                oeAjaxEventListner(ajaxCall);
                this.submitDetails(ajaxCall.url, ajaxCall.method, ajaxCall.body, this.header);
            }
        }

        _callAuthPage() {
                this.$.addressUpdateAuthorization.$$("#addressUpdateAuthorization").open();
            } //To display success toast


        _callSucessPage(event) {
            this.$.addressUpdateAuthorization.$$("#addressUpdateAuthorization").close();
            this.myprofilepagenumber = 8;
            var successMsg;
            /* if (this.selectedAddressDetail.updateScenario) {
                  successMsg = getLabel('l_addressWasUpdatedSuccessfully')
                } else {
                  successMsg = getLabel('l_addressWasAddedSuccessfully')
                }
                this.fire('oe-show-success', {
                  message: successMsg
                });
            */

            var convertedArr = event.detail.__data.xhr.getAllResponseHeaders().split('\r\n');
            var headers = convertedArr.reduce(function(each, current) {
                var parts = [current.split(": ", 1).toString(), current.split(": ").slice(1).join(": ")];
                each[parts[0]] = parts[1];
                return each;
            }, {});
            //adding message as a part of 337308 
            if (headers.channelcontext) {
                if (JSON.parse(headers.channelcontext).status.message[0].messageCode == "104738")
                    successMsg = getLabel('m_addedSuccefully');
                else
                    successMsg = getLabel('m_RequestSuccess');

                this.fire('oe-show-success', {
                    message: successMsg
                });
                this.fromEditPage = true;
            } else {
                this.fire('oe-show-error', event.detail.error.message);
            }
        }
        _continueToConfirm() {
            if (this.authenticationValidation(this.authMethods)) return;
            if (this.authMethods && this.authMethods.length == 1) this.header.primaryAccessCode = this.authMethods[0].wrapperValue;

            if (this.authMethods && this.authMethods.length == 2) {
                this.header.primaryAccessCode = this.authMethods[0].wrapperValue;
                this.header.secondaryAccessCode = this.authMethods[1].wrapperValue;
            }

            this.confirmAddress();
        }

        validate() {
            if (!this.selectedAddressDetail.addressDetails.streetNumber) {
                this.$$("#streetNumber").invalid = true;
                this.fire("oe-show-error", getLabel("m_EnterStreetNumber"));
                return false;
            } else if (!this.selectedAddressDetail.addressDetails.streetName) {
                this.$$("#street_name").invalid = true;
                this.fire("oe-show-error", getLabel("m_EnterStreetName"));
                return false;
            } else if (!this.selectedAddressDetail.addressDetails.cityDesc) {
                this.$$("#cityid").invalid = true;
                this.fire("oe-show-error", getLabel("m_EnterCity"));
                return false;
            } else if (this.selectedAddressDetail.addressDetails.country == {} || this.selectedAddressDetail.addressDetails.country == undefined || Object.keys(this.selectedAddressDetail.addressDetails.country).length === 0) {
                this.$$("#countrySelector").invalid = false;
                this.fire("oe-show-error", getLabel("l_select_country"));
                return false;
            } else if (this.$$("#countrySelector").shadowRoot.querySelector('#countrySelectorInputId').invalid) {
                return false;
            } else if (this.state == null || this.state == undefined || Object.keys(this.state).length === 0) {
                this.$$("#stateCombo").invalid = true;
                this.fire("oe-show-error", getLabel("l_select_state"));
                return false;
            } else if (!this.selectedAddressDetail.addressDetails.zipCode) {
                this.$$("#zipid").invalid = true;
                this.fire("oe-show-error", getLabel("m_EnterZipCode"));
                return false;
            } else {
                return true;
            }
        }

        _confirmBack() {
            if (_.isEqual(this.selectedAddressDetail.originalAddress, this.selectedAddressDetail.addressDetails) && _.isEqual(this.selectedAddressDetail.originalAddress.state, this.state) && this.selectedAddressDetail.tempFlag == true) {
                this.filterVal = undefined;
                this.myprofilepagenumber = 8;
                if(this.phone){
                document.getElementById('page-title-label').shadowRoot.children[4].children[4].children[1].classList.add('flex-2');
                }
            } else if (this.selectedAddressDetail.originalAddress == undefined && Object.keys(this.selectedAddressDetail.addressDetails).length === 0 && this.state == undefined && this.selectedAddressDetail.tempFlag == true) {
                this.filterVal = undefined;
                this.myprofilepagenumber = 8;
            } else {
                this.$.backNagigationPopup.$$("#backNagigationPopup").open();
            }
        }
        _cancelBack() {
            this.$.backNagigationPopup.$$("#backNagigationPopup").close();
        }
        _leftAction() {
                this.$.backNagigationPopup.$$("#backNagigationPopup").close();
                this.filterVal = undefined;
                this.myprofilepagenumber = 8;
            }
            //focused on Header
        _focusOnTitle() {
            if(this.phone){
            document.getElementById('page-title-label').shadowRoot.children[4].children[4].children[1].classList.remove('flex-2');
            }
            setTimeout(function() {
                this.$$("#address_edit_page").setAttribute("tabindex", "0");
                this.$$("#address_edit_page").focus();
            }.bind(this), 1000);
        }
        setFocus(event) {
            if (event.keyCode == 9) {
                this.shadowRoot.querySelector("#address_edit_page").focus();
            }
        }

    } // Associate the new class with an element name


customElements.define('profile-contact-details-address-edit', ProfileContactDetailsAddressEdit);